import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.unscopables.flat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url-search-params.js";
import { defineComponent as _defineComponent } from 'vue';
import moment from 'moment-timezone';
import IconSearch from '../components/general/icons/IconSearch.vue';
import BEvent from '@/components/general/BEvent.vue';
import BChip from '~/components/general/BChip.vue';
import BButton from '~/components/general/BButton.vue';
import { EVENT_TYPES, errorMessage, sortEvents } from '~/utils/utils';
import { toSearchEventData } from '~/utils/facebook';
import { useEventsStore } from '~/store/events';
import { useAppStore } from '~/store/app';

// Mirrors ExternalSortOptions from @tickethead/sdk, which defines it in
// dist/src/aggregator/types but doesn't re-export it from the package root.
var ExternalSortOptions = /*#__PURE__*/function (ExternalSortOptions) {
  // eslint-disable-next-line no-unused-vars
  ExternalSortOptions["Popularity"] = "popularity";
  // eslint-disable-next-line no-unused-vars
  ExternalSortOptions["Price"] = "price";
  // eslint-disable-next-line no-unused-vars
  ExternalSortOptions["Title"] = "title";
  // eslint-disable-next-line no-unused-vars
  ExternalSortOptions["Distance"] = "distance";
  // eslint-disable-next-line no-unused-vars
  ExternalSortOptions["Score"] = "score,";
  return ExternalSortOptions;
}(ExternalSortOptions || {});
const __nuxt_page_meta = {
  layout: 'default_v2'
}
export default /*#__PURE__*/_defineComponent({
  ...__nuxt_page_meta,__name: 'index',
  setup: function setup(__props) {
    ;
    var route = useRoute();
    var appStore = useAppStore();
    var eventsStore = useEventsStore();
    var sdk = useSdk();
    var notifier = useNotifier();
    var config = useRuntimeConfig();
    var whitelabel = useWhitelabel();
    var nuxtEventBus = useNuxtEventBus();
    var featureFlags = useFeatureFlags();
    var _useMetaPixel = useMetaPixel(),
      trackPlatformMetaEvent = _useMetaPixel.trackPlatformMetaEvent;
    var _useBreakpoint = useBreakpoint(),
      width = _useBreakpoint.width;
    var _useI18n = useI18n(),
      t = _useI18n.t;
    var externalFilterOptions = ref([{
      id: 1,
      label: t('home.featuredEvents.closest'),
      selected: false
    }, {
      id: 2,
      label: t('home.featuredEvents.popular'),
      selected: true
    }]);
    var externalEvents = ref([]);
    var externalEventsPage = ref(1);
    var nearMe = ref(false);
    var searchTerm = ref('');
    var categories = ref([]);
    var events = ref([]);
    var highlightedEvents = ref([]);
    var filteredEvents = ref([]);
    var showHeroImage = ref(true);
    var organizer = ref(null);
    var categoryFilter = ref([]);
    var getSearchTerm = computed(function () {
      return eventsStore.getSearchTerm;
    });
    var getOrganizerId = computed(function () {
      return eventsStore.getOrganizerId;
    });
    var highlightedEventsExist = computed(function () {
      var _highlightedEvents$va;
      return ((_highlightedEvents$va = highlightedEvents.value) === null || _highlightedEvents$va === void 0 ? void 0 : _highlightedEvents$va.length) > 0;
    });
    var whitelabeled = computed(function () {
      return whitelabel.lightTheme.backgroundPrimary.base.length;
    });
    var isMobileOrTablet = computed(function () {
      return width.value < 960;
    });
    var eventSearch = computed(function () {
      return isMobileOrTablet.value ? getSearchTerm.value.length : searchTerm.value.length;
    });
    var orgHasHeroText = computed(function () {
      var _organizer$value, _organizer$value$bran;
      return (_organizer$value = organizer.value) === null || _organizer$value === void 0 ? void 0 : (_organizer$value$bran = _organizer$value.branding) === null || _organizer$value$bran === void 0 ? void 0 : _organizer$value$bran.heroText;
    });
    var orgHasHeroImage = computed(function () {
      var _organizer$value2, _organizer$value2$bra;
      return !!((_organizer$value2 = organizer.value) !== null && _organizer$value2 !== void 0 && (_organizer$value2$bra = _organizer$value2.branding) !== null && _organizer$value2$bra !== void 0 && _organizer$value2$bra.heroImageUrl);
    });
    var homeTitle = computed(function () {
      if (getOrganizerId.value && orgHasHeroText.value) {
        return organizer.value.branding.heroText;
      }
      return t('home.hero.title');
    });
    function eventInPresale(event) {
      if (isRecurringEvent(event.type)) {
        return event.occurrence.some(function (occurrence) {
          return occurrence.presaleEndAt && moment(occurrence.presaleEndAt).isAfter(moment());
        });
      }
      return event.presaleEndAt && moment(event.presaleEndAt).isAfter(moment());
    }
    function isRecurringEvent(type) {
      return type === EVENT_TYPES.RECURRING;
    }
    function updateEventNames(evts) {
      evts.forEach(function (event) {
        if (eventInPresale(event)) {
          event.name = "[".concat(t('home.events.presale').toUpperCase(), "] ").concat(event.name);
        }
      });
    }
    function updateRecurringEventDates(evts) {
      var now = moment();
      evts.forEach(function (event) {
        if (isRecurringEvent(event.type)) {
          var _event$occurrence;
          event.occurrence = event.occurrence.filter(function (occurrence) {
            return moment(occurrence.endAt).isAfter(now);
          });
          sortEvents(event.occurrence);
          // Only update display value of start date of the event if there are occurrences ending in the future
          // We need to check this because recurring event end date might be in the future while all occurrences have already passed
          if ((_event$occurrence = event.occurrence) !== null && _event$occurrence !== void 0 && _event$occurrence.length) {
            event.startAt = event.occurrence[0].startAt;
          }
        }
      });
    }
    function filterExternalEvents(_x) {
      return _filterExternalEvents.apply(this, arguments);
    }
    function _filterExternalEvents() {
      _filterExternalEvents = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(option) {
        var filterOption;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              filterOption = externalFilterOptions.value.find(function (op) {
                return option.includes(op.id);
              });
              nearMe.value = filterOption.label === t('home.featuredEvents.closest');
              externalEventsPage.value = 1;
              _context2.next = 1;
              return fetchExternalEvents(externalEventsPage.value, nearMe.value);
            case 1:
              externalEvents.value = _context2.sent;
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return _filterExternalEvents.apply(this, arguments);
    }
    function loadMoreEvents() {
      return _loadMoreEvents.apply(this, arguments);
    }
    function _loadMoreEvents() {
      _loadMoreEvents = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var evts;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              externalEventsPage.value++;
              _context3.next = 1;
              return fetchExternalEvents(externalEventsPage.value, nearMe.value);
            case 1:
              evts = _context3.sent;
              externalEvents.value = [].concat(_toConsumableArray(externalEvents.value), _toConsumableArray(evts));
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return _loadMoreEvents.apply(this, arguments);
    }
    function searchEvents() {
      trackPlatformMetaEvent('Search', toSearchEventData(searchTerm.value));
      eventsStore.setSearchTerm(searchTerm.value);
    }
    function checkSearchEvents() {
      if (searchTerm.value.length === 0) {
        eventsStore.setSearchTerm(searchTerm.value);
      }
    }

    /**
     * Update own events only
     */
    function updateEvents() {
      return _updateEvents.apply(this, arguments);
    }
    /**
     * Fetch events from backend, apply filtering if needed
     */
    function _updateEvents() {
      _updateEvents = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              appStore.setLoading(true);
              _context4.next = 1;
              return fetchEvents();
            case 1:
              appStore.setLoading(false);
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      return _updateEvents.apply(this, arguments);
    }
    function fetchEvents() {
      return _fetchEvents.apply(this, arguments);
    }
    function _fetchEvents() {
      _fetchEvents = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var searchTermValue, organizerId, query, _t;
        return regeneratorRuntime.wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              searchTermValue = getSearchTerm.value || '';
              organizerId = getOrganizerId.value;
              query = {
                with: {
                  ticket_config: true,
                  subcategory: true,
                  occurrence: true
                },
                sort_by: 'created_at',
                direction: 'desc',
                future_events: true,
                name: searchTermValue
              }; // Do not filter out events if the marketplace is configured to show all
              if (organizerId && !config.whitelabel.showAllEvents) {
                query.organizer_id = organizerId;
              }
              _context5.next = 1;
              return sdk.aggregator.listEvents(query);
            case 1:
              events.value = _context5.sent.data;
              updateRecurringEventDates(events.value);
              updateEventNames(events.value);
              sortEvents(events.value);
              filteredEvents.value = events.value;

              // This also allows us to highlight the organizers events when
              // they are only embedded in an iframe. Is this useful or wanted?
              if (organizerId && config.whitelabel.highlightOwnEvents) {
                highlightedEvents.value = events.value.filter(function (event) {
                  return event.organizerId === organizerId;
                });
              } else {
                highlightedEvents.value = events.value.filter(function (event) {
                  return event.displayPriority > 0;
                });
              }
              _context5.next = 3;
              break;
            case 2:
              _context5.prev = 2;
              _t = _context5["catch"](0);
              notifier.showMessage({
                content: t('errors.fetchEvent'),
                type: 'error'
              });
            case 3:
            case "end":
              return _context5.stop();
          }
        }, _callee5, null, [[0, 2]]);
      }));
      return _fetchEvents.apply(this, arguments);
    }
    function fetchExternalEvents(_x2) {
      return _fetchExternalEvents.apply(this, arguments);
    }
    function _fetchExternalEvents() {
      _fetchExternalEvents = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee6(pageNumber) {
        var near,
          externalEventsData,
          externalEventsDataVM,
          _args6 = arguments,
          _t2;
        return regeneratorRuntime.wrap(function (_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              near = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : false;
              _context6.prev = 1;
              _context6.next = 2;
              return sdk.aggregator.listExternalEvents({
                page: pageNumber,
                near_me: near,
                sort: ExternalSortOptions.Popularity,
                page_size: 12
              });
            case 2:
              externalEventsData = _context6.sent;
              externalEventsDataVM = externalEventsData.map(function (eventsData) {
                return eventsData.events.map(function (event) {
                  return _objectSpread(_objectSpread({}, event), {}, {
                    provider: eventsData.name
                  });
                });
              });
              return _context6.abrupt("return", externalEventsDataVM.flat());
            case 3:
              _context6.prev = 3;
              _t2 = _context6["catch"](1);
              notifier.showMessage({
                content: errorMessage(_t2, t('errors.fetchEvent')),
                type: 'error'
              });
            case 4:
            case "end":
              return _context6.stop();
          }
        }, _callee6, null, [[1, 3]]);
      }));
      return _fetchExternalEvents.apply(this, arguments);
    }
    function getOrganizer() {
      return _getOrganizer.apply(this, arguments);
    }
    function _getOrganizer() {
      _getOrganizer = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var org, _t3;
        return regeneratorRuntime.wrap(function (_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;
              _context7.next = 1;
              return sdk.account.getOrganizer({
                id: getOrganizerId.value,
                fields: ['branding']
              });
            case 1:
              org = _context7.sent;
              organizer.value = org;
              nuxtEventBus.$emit('organizerFetched', org);
              _context7.next = 3;
              break;
            case 2:
              _context7.prev = 2;
              _t3 = _context7["catch"](0);
              notifier.showMessage({
                content: errorMessage(_t3, t('errors.fetchOrganizerInfo')),
                type: 'error'
              });
            case 3:
            case "end":
              return _context7.stop();
          }
        }, _callee7, null, [[0, 2]]);
      }));
      return _getOrganizer.apply(this, arguments);
    }
    function getCategories() {
      return _getCategories.apply(this, arguments);
    }
    function _getCategories() {
      _getCategories = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var _t4;
        return regeneratorRuntime.wrap(function (_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.prev = 0;
              _context8.next = 1;
              return sdk.aggregator.listCategories({
                with: {
                  subcategory: true
                },
                sort_by: 'active_events',
                active_events: true
              });
            case 1:
              categories.value = _context8.sent.data;
              categories.value = categories.value.filter(function (category) {
                return category.activeEvents > 0;
              });
              categories.value = categories.value.map(function (c) {
                return {
                  id: c.id,
                  label: c.name,
                  selected: false,
                  subcategory: c.subcategory.map(function (s) {
                    return {
                      id: s.id,
                      displayName: s.name
                    };
                  })
                };
              });
              handleCategoryPreselection();
              _context8.next = 3;
              break;
            case 2:
              _context8.prev = 2;
              _t4 = _context8["catch"](0);
              notifier.showMessage({
                content: t('errors.fetchCategories'),
                type: 'error'
              });
            case 3:
            case "end":
              return _context8.stop();
          }
        }, _callee8, null, [[0, 2]]);
      }));
      return _getCategories.apply(this, arguments);
    }
    function filterEventsByCategory(option) {
      if ((option === null || option === void 0 ? void 0 : option.length) === 0) {
        filteredEvents.value = events.value;
        return;
      }
      var subcategories = categories.value.find(function (category) {
        return option.includes(category.id);
      }).subcategory;
      var subcategoryIds = subcategories.map(function (subcategory) {
        return subcategory.id;
      });
      filteredEvents.value = events.value.filter(function (event) {
        var _event$subcategory;
        return subcategoryIds.includes((_event$subcategory = event.subcategory) === null || _event$subcategory === void 0 ? void 0 : _event$subcategory.id);
      });
    }
    function handleCategoryPreselection() {
      var urlParams = new URLSearchParams(window.location.search);
      var categoryId = parseInt(urlParams.get('category_id'));
      if (categoryId) {
        categoryFilter.value.push(categoryId);
        filterEventsByCategory(categoryFilter.value);
        var foundCategory = categories.value.find(function (category) {
          return category.id === categoryId;
        });
        foundCategory.selected = true;
      }
    }
    watch(getSearchTerm, function () {
      updateEvents();
    });
    onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var urlParams, hostname, organizerDomains, promises, _externalEventsPage$v;
      return regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            // hide the hero when embedded with ?hero_image=false
            urlParams = new URLSearchParams(window.location.search);
            if (urlParams.get('hero_image') === 'false') {
              showHeroImage.value = false;
            }

            // Filtering based on hostname we are serving this page from - localhost defaults to HOST_NAME (since localhost is not supported by backend)
            hostname = window.location.host.includes('localhost') ? process.env.HOST_NAME : window.location.host; // fetch matching organizer-domains
            _context.next = 1;
            return sdk.account.listDomains({
              name: hostname
            });
          case 1:
            organizerDomains = _context.sent;
            // if we found a matching organizer domain, filter for it
            if (organizerDomains.length > 0) {
              eventsStore.setOrganizerId(organizerDomains[0].organizerId);
            }
            // if the marketplace is deployed as a whitelabel
            else if (config.whitelabel.enabled) {
              eventsStore.setOrganizerId(config.whitelabel.organizer);
            }
            // ...otherwise fallback to filtering by query-parameter
            else if (route.query.organizer_id) {
              // vue-router resolves a repeated query key to an array; every actual
              // consumer of getOrganizerId expects a single id, so take the first one
              eventsStore.setOrganizerId(Array.isArray(route.query.organizer_id) ? route.query.organizer_id[0] : route.query.organizer_id);
            }
            // ...if nothing matches, reset to no filtering
            else {
              eventsStore.setOrganizerId(null);
            }
            appStore.setLoading(true);
            // reset search term on page load
            eventsStore.setSearchTerm('');
            promises = [fetchEvents()];
            if (getOrganizerId.value) {
              promises.push(getOrganizer());
            }
            _context.next = 2;
            return Promise.all(promises);
          case 2:
            if (!(featureFlags.featuredEvents && !getOrganizerId.value)) {
              _context.next = 4;
              break;
            }
            _context.next = 3;
            return fetchExternalEvents((_externalEventsPage$v = externalEventsPage.value) !== null && _externalEventsPage$v !== void 0 ? _externalEventsPage$v : 1, nearMe.value);
          case 3:
            externalEvents.value = _context.sent;
          case 4:
            _context.next = 5;
            return getCategories();
          case 5:
            appStore.setLoading(false);
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    return {
      __sfc: true,
      ExternalSortOptions: ExternalSortOptions,
      route: route,
      appStore: appStore,
      eventsStore: eventsStore,
      sdk: sdk,
      notifier: notifier,
      config: config,
      whitelabel: whitelabel,
      nuxtEventBus: nuxtEventBus,
      featureFlags: featureFlags,
      trackPlatformMetaEvent: trackPlatformMetaEvent,
      width: width,
      t: t,
      externalFilterOptions: externalFilterOptions,
      externalEvents: externalEvents,
      externalEventsPage: externalEventsPage,
      nearMe: nearMe,
      searchTerm: searchTerm,
      categories: categories,
      events: events,
      highlightedEvents: highlightedEvents,
      filteredEvents: filteredEvents,
      showHeroImage: showHeroImage,
      organizer: organizer,
      categoryFilter: categoryFilter,
      getSearchTerm: getSearchTerm,
      getOrganizerId: getOrganizerId,
      highlightedEventsExist: highlightedEventsExist,
      whitelabeled: whitelabeled,
      isMobileOrTablet: isMobileOrTablet,
      eventSearch: eventSearch,
      orgHasHeroText: orgHasHeroText,
      orgHasHeroImage: orgHasHeroImage,
      homeTitle: homeTitle,
      eventInPresale: eventInPresale,
      isRecurringEvent: isRecurringEvent,
      updateEventNames: updateEventNames,
      updateRecurringEventDates: updateRecurringEventDates,
      filterExternalEvents: filterExternalEvents,
      loadMoreEvents: loadMoreEvents,
      searchEvents: searchEvents,
      checkSearchEvents: checkSearchEvents,
      updateEvents: updateEvents,
      fetchEvents: fetchEvents,
      fetchExternalEvents: fetchExternalEvents,
      getOrganizer: getOrganizer,
      getCategories: getCategories,
      filterEventsByCategory: filterEventsByCategory,
      handleCategoryPreselection: handleCategoryPreselection,
      IconSearch: IconSearch,
      BEvent: BEvent,
      BChip: BChip,
      BButton: BButton
    };
  }
});